<template>
<div>
     <div class="invoiceList">
        <v-layout row wrap>
            <v-flex xs12>
              <v-card class="primary white--text text-xs-center body-2">
                <v-card-text>
                    <h3>{{heading}}</h3>
                </v-card-text>
              </v-card>
            </v-flex>
        </v-layout>
            <!-- <v-data-table :items="invoicesByBrand" class="elevation" :headers="headers"> -->
            <v-data-table :items="invoicesByBrand" class="elevation transaction-table strip-table" hide-actions :headers="headers">
            <template slot="items" slot-scope="props">
                <automatic-invoice 
                    v-if='props.item.type == "automatic invoice" && props.item.firm != "Total"'
                    :item=props.item
                    :firms="firms"
                />
                 <normal-invoice 
                    v-if='props.item.type != "automatic invoice" && props.item.firm != "Total"'
                    :item=props.item
                    :firms="firms"
                    :buyers="buyers"
                    :sellers="sellers"
                />
                <tr v-if='props.item.firm == "Total"'>
                    <td><b class="font-weight-bold primary--text">Total</b></td>
                    <td><b class="font-weight-bold" ></b></td>
                    <template>    
                    <td class="credit-total"> <b class="green--text font-weight-bold "> {{props.item.credit || 0 | amount}} </b></td>        
                    <td class="debit-total"> <b class="red--text font-weight-bold "> {{props.item.debit || 0 | amount }} </b></td>
                    </template>
                    <td><b class="font-weight-bold"></b></td>
                    <td><b class="font-weight-bold"></b></td>
                    <td><b class="font-weight-bold"></b></td>
                    <td><b class="font-weight-bold"></b></td>
                </tr>
            </template>
            <template slot="no-data">No rows to Show</template>
            </v-data-table>
        </div>
    </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'

const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
const mapBuyerGetters = createNamespacedHelpers('Buyer')['mapGetters']

import { convertToPDFTransactionReport } from "../../utils/pdf-reports/transaction-reports";
import { convertToPDFTransactionStripReport } from "../../utils/pdf-reports/transaction-stripReports";

import {DateTime, Interval} from 'luxon'
import normalInvoice from './normalInvoice'
import automaticInvoice from './automaticInvoice'

export default {
    components: {
      normalInvoice,
      automaticInvoice
    },
    props: {
        isCredited: {
            type: Boolean,
            default: true
        }, 
        voucherTypeFilter: {
            type: Array,
            default: []
        },
        invoices: {
            type: Array,
            default: []
        },
        firms: {
            type: Array,
            default: []
        },
        sellers: {
            type: Object,
            default: []
        },
        buyers: {
            type: Object,
            default: []
        },
        status: {
            type: Array,
            default: () => {
                return ['Paid']
            }
        },
        print: {
            type: Boolean,
            default: false
        },
        stripPrint: {
            type: Boolean,
            default: false
        },
        firmAssignment: {
            type: Boolean,
            default: false
        },
        heading: {
            type: String,
            default: ""
        },
        selectedFirm: {
            type: String,
            default: null
        },
        selectedDate: {
            type: String,
            default: () => {
                let today = new Date()
                return `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}` 
            }
        }
    },
    data: () => ({
        headers: [
        // { text: "Invoice ID", value: "expense", sortable: true },
        { text: "Firm", value: "expense", sortable: true },
        { text: "Particulars", value: "name", sortable: true },
        { text: "Debit", value: "category", sortable: true },
        { text: "Credit", value: "underHead", sortable: false },
        { text: "Voucher type", value: "totalAmount", sortable: false },
        { text: "Payment type", value: "totalAmount", sortable: false },
        // { text: "Transaction type", value: "totalAmount", sortable: false },
        { text: "Status", value: "status", sortable: true },
        { text: "Remark", sortable: false },
        ],
    }),
    watch:{
        print(newVal, oldVal) { 
            if(newVal) {
                this.printInvoices();
            }        
        },
        stripPrint(newVal, oldVal) { 
            if(newVal) {
                this.stripPrintInvoices();
            }        
        }
    },
    created () {
        this.$bindAsArray('invoiceHistory', this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand))
        this.$bindAsArray("customerPayments",this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand))
        this.$bindAsArray ("deposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    },
    computed: {
        ...mapGlobalGetters(['selectedBrand','brandFinYear']),
        invoicesByBrand () {
            let invoiceHistory  =  this.invoiceHistory.filter((item) => 
                item['brand'] === this.selectedBrand && 
                // this.status.indexOf(item['status']) !== -1 && 
                // (this.datatable ? true : item['isCredited'] === this.isCredited) &&
                 (item.deleted != true) &&
                ((this.selectedFirm) ? (item['firm'] === this.selectedFirm): true) &&
                // ((this.selectedDate) ? (new Date(this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString()): false)
                (item.closedDate ? 
                ((this.selectedDate) ? (new Date(this.selectedDate).toLocaleDateString() === new Date(item['closedDate']).toLocaleDateString()): false) : 
                ((this.selectedDate) ? (new Date(this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString()): false))
                && (item['isLatest'] != undefined ? item['isLatest'] == true : true)
            )
            invoiceHistory.map((item,index)=>{
                invoiceHistory[index]['buyerName'] = this.buyerById(item.buyerId)
                if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
                    let newItem = JSON.parse(JSON.stringify(item));
                    newItem.date = newItem.date-1;
                    newItem.transactionType = "Debit";
                    newItem.paidAmount = 0;
                    newItem.status = 'due';
                    newItem.remainingAmount = newItem.totalAmount;
                    delete newItem['newlyCreated'];
                    invoiceHistory.push(newItem);
                }
              })
              let invoice =  this.invoices.filter((item) => 
                item['brand'] === this.selectedBrand && 
                (item.deleted != true) &&
                item.type == "automatic invoice" &&
                ((this.selectedFirm) ? (item['firm'] === this.selectedFirm): true) &&
                ((this.selectedDate) ? (new Date(this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString()): false)
                && (item['isLatest'] != undefined ? item['isLatest'] == true : true)
            )

            let customerDeposit  = this.deposit.filter(
                item =>
                item["brand"] === this.selectedBrand &&
                ((this.selectedFirm) ? (item['firm'] === this.selectedFirm): true) &&
                ((this.selectedDate) ? (new Date(this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString()): false) &&
                (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security")
            );
             customerDeposit.map((deposit)=>{
                if(deposit.buyerId) {
                    deposit['buyerName'] = this.buyerById(deposit.buyerId)
                }
                invoice.push(deposit)
                // if((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status =="paid") {
                // let temp = JSON.parse(JSON.stringify(deposit))
                // temp.status = 'due';
                // invoice.push(temp);
                // }
            })
            let payments  = this.customerPayments.filter(
                item =>
                item["brand"] === this.selectedBrand &&
                (Number.parseFloat(item["remainingAmount"]) > 0) &&
                (!!this.selectedFirm ? item["firm"] === this.selectedFirm : true) && 
                ((this.selectedDate) ? (new Date(this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString()): false)
            );
            payments.map((pay)=>{
                if(pay.buyerId) {
                    pay['buyerName'] = this.buyerById(pay.buyerId)
                }
                pay['type'] = 'CustomerPayment'
                invoice.push(pay)
            })
            setTimeout(() => {
                this.getTotal()
            }, 800);
            invoice = invoice.concat(invoiceHistory);
            invoice.map((item,index)=>{
                invoice[index]['voucherType'] = this.getVocherType(item);
            })
            if(this.voucherTypeFilter.length) {
                invoice = invoice.filter(it => this.voucherTypeFilter.indexOf(it['voucherType']) > -1);
            }
            invoice.sort((a, b) => (a.buyerName > b.buyerName) ? 1 : -1)
            invoice.push({
                firm : 'Total'
            })
            return invoice;
        },
        firmsByBrand () {
            return this.firms.filter((item) => 
                item['brand'] === this.selectedBrand
            )
        }
    },
    methods: {
        buyerById (id) {
            if (this.buyers[id]) {
                return this.buyers[id].name
            } else if (this.sellers[id]) {
                return this.sellers[id].name
            } else {
                return "--DELETED--"
            }
        },
         getTotal(isCredit){
              const tableElement = document.querySelector('.transaction-table table');
                if(tableElement) {
                        const thead = tableElement.querySelector('thead');
                        const tbody = tableElement.querySelector('tbody');
                        // Assumes there's only one header row
                        const columns = thead.querySelectorAll('tr th');
                        const columnNames = [];
                        columns.forEach( c => columnNames.push(c.innerText));
                        const result = [];
                        const bodyRows = tbody.querySelectorAll('tr');
                        bodyRows.forEach( r => {
                            const tds = r.querySelectorAll('td');
                            const arr = [];
                            tds.forEach( (td, idx) => {
                            arr.push(td.innerText);
                            if(td.classList.contains("credit-total")) {
                                let total = 0;
                                result.map((a)=>{
                                    if(a[0]!='Total') {
                                        let amount  = Number.parseFloat(0+a[2].replaceAll(",",""));
                                        total += amount
                                    }
                                }) 
                                 td.querySelector("b").innerHTML = Number.parseFloat(total.toFixed(2)).toLocaleString('en-IN');
                            }
                            if(td.classList.contains("debit-total")) {
                                let total = 0;
                                result.map((a)=>{
                                    if(a[0]!='Total') {
                                        let amount  = Number.parseFloat(0+a[3].replaceAll(",",""));
                                        total += amount
                                    }
                                }) 
                                td.querySelector("b").innerHTML = Number.parseFloat(total.toFixed(2)).toLocaleString('en-IN');
                            }
                            });
                            result.push(arr);
                        });
                    return result;
                }
                let total = 0;
                    invoices.map((a)=>{
                        if(a[0]!='Total') {
                            let amount  = isCredit ? Number.parseFloat(0+a[2].replaceAll(",","")) : Number.parseFloat(0+a[3].replaceAll(",",""))
                            total += amount
                        }

                    })
                    return total;
                    
            },
             htmlToArray  () {
                const tableElement = document.querySelector('.transaction-table table');
                if(tableElement) {
                        const thead = tableElement.querySelector('thead');
                        const tbody = tableElement.querySelector('tbody');
                        // Assumes there's only one header row
                        const columns = thead.querySelectorAll('tr th');
                        const columnNames = [];
                        columns.forEach( c => columnNames.push(c.innerText));
                        const result = [];
                        const bodyRows = tbody.querySelectorAll('tr');
                        bodyRows.forEach( r => {
                            const tds = r.querySelectorAll('td');
                            const arr = [];
                            tds.forEach( (td, idx) => {
                            arr.push(td.innerText);
                            });
                            result.push(arr);
                        });
                    return result;
                }
                return [];
            },
        printInvoices(){
            let invoices = this.htmlToArray();
            let firm = this.firms.filter(item => item['.key'] == this.selectedFirm)[0]
            let doc = convertToPDFTransactionReport({
                invoiceData:invoices,
                firm: this.selectedFirm ? firm.name : '',
                date : this.selectedDate ? new Date(this.selectedDate).toLocaleDateString('en-GB') : ''
            });
            pdfMake.createPdf(doc).download('Daybook_'+ new Date(this.selectedDate).toLocaleDateString('en-GB'));
        },
        stripPrintInvoices(){
            let invoices = this.htmlToArray();
            let firm = this.firms.filter(item => item['.key'] == this.selectedFirm)[0]
            let doc = convertToPDFTransactionStripReport({
                invoiceData:invoices,
                firm: this.selectedFirm ? firm.name : '',
                date : this.selectedDate ? new Date(this.selectedDate).toLocaleDateString('en-GB') : ''
            });
            pdfMake.createPdf(doc).download('Daybook_'+ new Date(this.selectedDate).toLocaleDateString('en-GB'));
        },   
        getVocherType(invoice) {
            if(invoice.type == 'CustomerPayment') {
                if (invoice.isBuyer) {
                return "Receipt";
                } else {
                return "Payment";
                }
            }
            if (invoice.return) {
                if (invoice.isBuyer) {
                return "Credit Note";
                } else {
                return "Debit Note";
                }
            }
            if (invoice["type"] == "automatic invoice" && invoice.assetType) {
                return "Asset";
            }
            if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
                return "Expense";
            }
            if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
                return "Liability";
            }
            if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
                return "Income";
            }
            if (invoice["type"] == "automatic invoice" && invoice.staffType) {
                return "Staff";
            }
            if (
                invoice["type"] == "automatic invoice" &&
                invoice.transactionType === "Transfer"
            ) {
                return "Transfer";
            } 
            else if (
                (invoice.transactionType != "Debit" && invoice["type"] === "Advance") ||
                // invoice["type"] === "Opening Balance" ||
                invoice["type"] === "LoanGiven" || 
                invoice["type"] === "LoanTaken" ||
                invoice["type"] === "Security"
            ) {
                return invoice["type"];
            }
            else if ( invoice["type"] === "Opening Balance" && !invoice["settledAmount"]  ) {
                return "Opening Balance"
            }
            else if ( invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]  ) {
                return "Receipt"
            } 
            else if ( !invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]  ) {
                return "Payment"
            } 
            else if (invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Sale";
            } 
            else if (invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Receipt";
            }
            else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Receipt";
            }
            else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Purchase";
            }
            else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Payment";
            }
            else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Payment";
            }
        }
    }
}
</script>

<style>
    .flexColumn {
        flex-direction: column;
        align-items: flex-start;
    }
    
</style>
<style>
.strip-table tbody tr:nth-child(odd){
 background-color: #d5d5d5;
}
</style>


// WEBPACK FOOTER //
// src/components/DailyTransactions/invoiceList.vue